// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"85e5501f","455":"14e38429","977":"b79ba0ff"}[chunkId] + ".chunk.js";
};